'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useConversationContext } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationHeaderActions = /*#__PURE__*/React.forwardRef(function ConversationHeaderActions(props, ref) {
  const {
      children,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = useConversationContext();
  const Actions = slots?.actions ?? 'div';
  const actionsProps = useSlotProps({
    elementType: Actions,
    externalSlotProps: slotProps?.actions,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Actions, _extends({}, actionsProps, {
    children: children
  }));
});
if (process.env.NODE_ENV !== "production") ConversationHeaderActions.displayName = "ConversationHeaderActions";